export const namespaced = true;

const defaultData = {
    chooseProducts: []
}

export const state = () => (defaultData);

export const getters = {
    getChooseProducts: state => state.chooseProducts,
}

export const mutations = {
    mutateChooseProducts(state, chooseProducts) {
        state.chooseProducts = chooseProducts
    }
};

export const actions = {
    setChooseProducts({commit}, chooseProducts) {
        return new Promise((resolve, reject) => {
            commit('mutateChooseProducts', chooseProducts);
            resolve()
        })
    },
    resetData({commit}) {
        return new Promise((resolve, reject) => {
            commit('mutateChooseProducts', defaultData);
            resolve()
        })
    }
};

